// Reusable prop spinner overlay for AI loading states.
//
// Usage:
//   import { showPropSpinner, hidePropSpinner } from './prop_spinner'
//
//   const spinner = showPropSpinner(anchorElement, 'Generating...')
//   // ... async work ...
//   hidePropSpinner(spinner)

const SPINNER_ID = 'prop-spinner-overlay';
const KEYFRAME_ID = 'prop-spin-keyframes';

function ensureKeyframes() {
  if (document.getElementById(KEYFRAME_ID)) return;
  const style = document.createElement('style');
  style.id = KEYFRAME_ID;
  style.textContent = '@keyframes prop-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}

const SVG = `
  <svg width="52" height="52" viewBox="0 0 52 52" style="animation:prop-spin 0.9s linear infinite; margin-bottom:8px;">
    <circle cx="26" cy="26" r="4.5" fill="#0d6efd"/>
    <ellipse cx="26" cy="13" rx="5" ry="12" fill="#0d6efd" opacity="0.85"/>
    <ellipse cx="26" cy="13" rx="5" ry="12" fill="#0d6efd" opacity="0.85" transform="rotate(120 26 26)"/>
    <ellipse cx="26" cy="13" rx="5" ry="12" fill="#0d6efd" opacity="0.85" transform="rotate(240 26 26)"/>
  </svg>
`;

export function showPropSpinner(anchor, message = 'Loading…') {
  ensureKeyframes();
  hidePropSpinner(); // clear any existing

  const overlay = document.createElement('div');
  overlay.id = SPINNER_ID;
  overlay.style.cssText = 'position:absolute; inset:0; background:rgba(255,255,255,0.85); display:flex; flex-direction:column; align-items:center; justify-content:center; border-radius:4px; z-index:10;';
  overlay.innerHTML = SVG + `<small class="text-muted">${message}</small>`;

  anchor.style.position = 'relative';
  anchor.appendChild(overlay);
  return overlay;
}

export function hidePropSpinner() {
  document.getElementById(SPINNER_ID)?.remove();
}
